import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TransactionPresetsService } from 'src/app/services/transaction-presets.service';
import { TransactionPreset, TransactionPresetPattern } from '@contracts/interfaces/transaction-preset.interface';
import { COGS, OperatingExpenses } from '@contracts/interfaces/transaction.interfaces';

@Component({
  selector: 'app-transaction-preset-dialog',
  templateUrl: './transaction-preset.dialog.html',
  styleUrls: ['./transaction-preset.dialog.scss', '../common-dialog-styles.scss']
})
export class TransactionPresetDialogComponent implements OnInit {

  presets: TransactionPreset[] = [];
  editing: TransactionPreset = this.buildBlankPreset();
  isSaving = false;
  isLoading = false;

  categories = [{ label: 'Uncategorised', value: 'uncategorised' }, ...COGS, ...OperatingExpenses];

  constructor(
    private dialogRef: MatDialogRef<TransactionPresetDialogComponent>,
    private transactionPresetsService: TransactionPresetsService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.isLoading = true;
    this.transactionPresetsService.list().subscribe(presets => {
      this.presets = presets;
      this.isLoading = false;
      // Keep selection in sync
      if (this.editing?._id) {
        const found = this.presets.find(p => p._id === this.editing._id);
        if (found) {
          this.editing = { ...found };
        }
      }
    }, () => {
      this.isLoading = false;
    });
  }

  selectPreset(preset: TransactionPreset) {
    this.editing = {
      ...preset,
      patterns: (preset.patterns || []).map(p => ({ ...p }))
    };
  }

  startNew() {
    this.editing = this.buildBlankPreset();
  }

  save() {
    if (!this.editing.name || !this.editing.atocategory) {
      return;
    }
    this.isSaving = true;
    const sanitized: TransactionPreset = {
      ...this.editing,
      patterns: (this.editing.patterns || [])
        .filter(p => p && p.pattern)
        .map(p => ({ pattern: p.pattern, flags: p.flags, example: p.example }))
    };

    const action = sanitized._id
      ? this.transactionPresetsService.update(sanitized)
      : this.transactionPresetsService.create(sanitized);

    action.subscribe(() => {
      this.isSaving = false;
      this.load();
      if (!this.editing._id) {
        this.startNew();
      }
    }, () => {
      this.isSaving = false;
    });
  }

  delete(preset: TransactionPreset) {
    if (!preset?._id) return;
    this.isSaving = true;
    this.transactionPresetsService.delete(preset._id).subscribe(() => {
      this.isSaving = false;
      this.startNew();
      this.load();
    }, () => {
      this.isSaving = false;
    });
  }

  addPattern() {
    if (!this.editing.patterns) {
      this.editing.patterns = [];
    }
    this.editing.patterns.push({ pattern: "", flags: "", example: "" });
  }

  removePattern(index: number) {
    if (!this.editing.patterns) return;
    this.editing.patterns.splice(index, 1);
  }

  close() {
    this.dialogRef.close();
  }

  private buildBlankPreset(): TransactionPreset {
    return {
      name: '',
      atocategory: 'uncategorised',
      hasGST: true,
      requiresEvidence: true,
      patterns: [{
        pattern: "",
        flags: "",
        example: "Example: Visa Purchase\\s+(?<date>\\d{2}[A-Za-z]{3})"
      }]
    };
  }
}
